import camelCase from "lodash-es/camelCase";
import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { footerInteractionTracking } from "../../../../../../../services/analytics.service";
import { translate } from "../../../../../../../services/translation.service";
import theme, { media } from "../../../../../../../theme";
import Hyperlink from "../../../../../../Hyperlink";
import { P } from "../../../../../../Semantic";

const Mentions = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.laptop} {
    flex-direction: row;
    justify-content: center;
    margin: ${theme.margins.marginBase} 0;
  }
`;

const Copyright = styled(P)`
  color: ${theme.colors.grey};
  font-size: ${theme.fontSizes.small};
`;

const Links = styled.div`
  text-align: center;
`;

const StyledLink = styled(Hyperlink)`
  color: ${theme.colors.grey};
  text-decoration: none;
  font-size: ${theme.fontSizes.small};
  display: inline;

  &:not(:last-child):after {
    content: " | ";
  }
`;

export default class LegalNotice extends PureComponent {
  public render(): ReactNode {
    return (
      <Mentions>
        <Copyright>{translate("footer.maisonDuWhiskyRights")} </Copyright>
        <Links>
          <StyledLink
            to={translate("links.legalNotices")}
            onClick={(): void =>
              footerInteractionTracking(
                camelCase(translate("footer.legalNotices"))
              )
            }
          >
            {translate("footer.legalNotices").replace(/ /g, "\u00a0")}
          </StyledLink>
          <StyledLink
            to={translate("links.personalData")}
            onClick={(): void =>
              footerInteractionTracking(
                camelCase(translate("footer.personalData"))
              )
            }
          >
            {translate("footer.personalData").replace(/ /g, "\u00a0")}
          </StyledLink>
          <StyledLink
            to={translate("links.cookiesPolicy")}
            onClick={(): void =>
              footerInteractionTracking(
                camelCase(translate("footer.cookiesPolicy"))
              )
            }
          >
            {translate("footer.cookiesPolicy").replace(/ /g, "\u00a0")}
          </StyledLink>
        </Links>
      </Mentions>
    );
  }
}
